module.exports = __webpack_public_path__ + "img/san-jose-hotel.a7d07dca.jpg";